export default "__VITE_ASSET__CEi5bvVC__"